export default __webpack_public_path__ + "static/media/extensions.8fa0a9b4.yaml";